/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';
import { awsconfig } from './aws-exports';

// Convert awsconfig class to plain object for Amplify v6
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-gov-west-1_GoIYxq6rQ',
      userPoolClientId: '1bk24a0hvb5qbjd4nvvm60bg44',
      region: 'us-gov-west-1',
    }
  }
};

Amplify.configure(amplifyConfig);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

/* PavCon, LLC Proprietary.All rights reserved 2022 */
